// Display helpers. Values are stored in millimetres; figures from geometry.js are m, m², m³.

const LOCALES = { de: "de-DE", en: "en-GB", tr: "tr-TR", ar: "ar" };
const locale = lng => LOCALES[lng] || "de-DE";

/** Millimetres as metres for an input field: 3450 → "3,45", 3455 → "3,455". */
export const mmToInput = (mm, lng) => {
  if (!mm) return "";
  return new Intl.NumberFormat(locale(lng), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
    useGrouping: false
  }).format(mm / 1000);
};

/** Millimetres for reading: "3,45 m". */
export const formatLength = (mm, lng) => (mm ? `${mmToInput(mm, lng)} m` : "–");

const figure = (value, lng, unit) =>
  `${new Intl.NumberFormat(locale(lng), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value || 0)} ${unit}`;

export const formatM = (value, lng) => figure(value, lng, "m");
export const formatM2 = (value, lng) => figure(value, lng, "m²");
export const formatM3 = (value, lng) => figure(value, lng, "m³");

/** "± 4 mm" / "± 1,2 cm" for a measuring uncertainty in mm. */
export const formatUncertainty = (mm, lng) => {
  if (mm === null || mm === undefined) return "";
  if (mm < 10) return `± ${Math.max(1, Math.round(mm))} mm`;
  return `± ${new Intl.NumberFormat(locale(lng), { maximumFractionDigits: 1 }).format(mm / 10)} cm`;
};

/** Speech recognition language tag for the UI language. */
export const speechLanguage = lng =>
  ({ de: "de-DE", en: "en-US", tr: "tr-TR", ar: "ar-SA" })[lng] || "de-DE";
